import React from 'react';

import { Box, Container, Hidden, Stack, Typography } from '@mui/material';
import { Link, graphql } from 'gatsby';
import { Trans, useTranslation } from 'react-i18next';

import DocOverviewCard from '../../features/Home/components/DocOverviewCard';
import useLocation from '../../hooks/useLocation';

// ********************************************************************************
export const requiredDocumentationMapping = (props: any, locale: string) => {
  let suffix = '_en';
  if (locale === 'es') {
    suffix = '_es';
  }
  return {};
};

type Props = {};
export const RequiredDocumentation: React.FC<Props> = () => {
  const { location } = useLocation();
  const { t } = useTranslation();

  // == Render ====================================================================
  return (
    <Box bgcolor="#F3F2F5" py={6}>
      <Container maxWidth="lg">
        <Stack spacing={5}>
          <Stack spacing={1}>
            <Typography variant="h2" color="#3F2B56" fontFamily="Gotham-Bold" fontSize="24px" align="left">
              {t('requiredDocumentation.title')}
            </Typography>
            <Typography variant="body1" color="#333334" fontSize="16px" textAlign="left" lineHeight="20px" mt={2}>
              {t('requiredDocumentation.description')}
            </Typography>
            <Typography
              fontSize="16px"
              color="#333334"
              lineHeight="20px"
              sx={{
                a: {
                  color: '#EF60A3',
                  fontFamily: 'Gotham-Medium',
                  textDecoration: 'underline',
                },
              }}
            >
              <Trans i18nKey="requiredDocumentation.requirements" components={[<Link to="/requirements" />]} />
            </Typography>
          </Stack>

          <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center" gap={2} mx="auto">
            <Box width="368px" height="643px">
              <DocOverviewCard type={location?.documentation[0]} widgetView />
            </Box>

            <Hidden mdUp>
              <Box width="368px">
                <Typography
                  variant="body1"
                  color="#333334"
                  fontSize="20px"
                  textAlign="left"
                  lineHeight="24px"
                  fontFamily="Gotham-Bold"
                >
                  {t('requiredDocumentation.forOtherCitizenships')}
                </Typography>
              </Box>
            </Hidden>

            <Box width="368px" height="643px">
              <DocOverviewCard type={location?.documentation[1]} widgetView />
            </Box>
            <Box width="368px" height="643px">
              <DocOverviewCard type={location?.documentation[2]} widgetView />
            </Box>
          </Stack>

          <Typography variant="body1" color="#333334" fontSize="16px" textAlign="left" lineHeight="20px">
            {t('requiredDocumentation.disclaimer')}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment RequiredDocumentation on StrapiWidgetrels {
    requiredDocumentation {
      key: id
      widgetPosition
    }
  }
`;
